import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { SmartImg } from './SmartImg';
import { IllustrativeBadge } from '../../components/IllustrativeBadge';

// Slider antes/depois com arrasto fluido (touch + mouse). `before`/`after` são URLs; `beforeThumb`/`afterThumb` aparecem na hora enquanto a imagem final carrega.
export const BeforeAfter = ({ before, after, beforeThumb, afterThumb, labels = { before: 'Before', after: 'After' }, note, aspect = '4 / 3', className = '', style, handleOnly = false, testId = 'before-after', children }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = (clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.max(2, Math.min(98, ((clientX - r.left) / r.width) * 100)));
  };
  const onDown = (e) => {
    if (handleOnly && !e.target.closest?.('[data-handle]')) return; // zoom: arrastar fora do botão = mover a foto
    e.stopPropagation();
    dragging.current = true; ref.current?.setPointerCapture?.(e.pointerId); update(e.clientX);
  };
  const onMove = (e) => { if (dragging.current) update(e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div ref={ref} onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp} className={`relative select-none overflow-hidden bg-slate-900 touch-none ${handleOnly ? 'cursor-grab' : 'cursor-ew-resize'} ${className}`} style={{ aspectRatio: aspect, ...style }} data-testid={testId}>
      <SmartImg src={after} placeholder={afterThumb} alt={labels.after} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <SmartImg src={before} placeholder={beforeThumb} alt={labels.before} className="absolute inset-0 h-full object-cover" style={{ width: `${10000 / pos}%`, maxWidth: 'none' }} draggable={false} />
      </div>
      <div className="absolute top-0 bottom-0 w-[2px] bg-white/95 shadow-[0_0_0_1px_rgba(0,0,0,.35)]" style={{ left: `${pos}%` }}>
        <motion.span data-handle whileTap={{ scale: 0.9 }} className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-12 w-12 rounded-full bg-white text-teal-700 flex items-center justify-center shadow-xl ring-4 ring-white/40 cursor-ew-resize" data-testid={`${testId}-handle`}>
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 7l-5 5 5 5M16 7l5 5-5 5" /></svg>
        </motion.span>
      </div>
      <span className="absolute top-3 left-3 rounded-full bg-black/55 backdrop-blur text-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em]">{labels.before}</span>
      <span className="absolute top-3 right-3 rounded-full bg-teal-600 text-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em]">{labels.after}</span>
      {note && <IllustrativeBadge text={note} className="bottom-3 right-3" testId={`${testId}-illustrative`} />}
      {children}
    </div>
  );
};
